export const SOFTLINE_API_WWS_ARTIKELBASISSTAND = 'v1/basisartikel/entities/{{datum}}';
export const SOFTLINE_API_WWS_ARTIKELBASISSTAND_SET = 'v1/basisartikel/entities';